import { coerceSave, looksLikeSave, type SaveState } from "./schema";

export type ImportResult = { ok: true; save: SaveState } | { ok: false; reason: string };

export function exportSave(state: SaveState): string {
  return JSON.stringify(
    { app: "nine-scrolls", exported: new Date().toISOString(), ...state },
    null,
    2,
  );
}

export function exportFilename(name: string, date = new Date()): string {
  const safe = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  return `nine-scrolls${safe ? "-" + safe : ""}-${date.toISOString().slice(0, 10)}.json`;
}

/** Accepts an export file, or a raw prototype save copied from localStorage. */
export function importSave(text: string): ImportResult {
  let raw: unknown;
  try {
    raw = JSON.parse(text);
  } catch {
    return { ok: false, reason: "That file isn't valid JSON." };
  }
  if (!looksLikeSave(raw))
    return { ok: false, reason: "That doesn't look like a Nine Scrolls save." };
  return { ok: true, save: coerceSave(raw) };
}
